export const messageBoxSuccess = ({ contentDe, contentEn }: { contentDe: string; contentEn: string }) => {
  const language: string | null = document.documentElement.lang ?? '';

  const messageBox = document.querySelector('.m-message-box__single-success') as HTMLElement;

  if (
    (language === 'en-US' && contentEn == "" )
    || (language !== 'en-US' && contentDe == "" )
  ) {
    return;
  }

  (messageBox.querySelector('.js-message-box__single-title') as HTMLElement).innerHTML = language === 'en-US' ? contentEn : contentDe;
  messageBox.classList.add('is-active');

  setTimeout(() => {
    messageBox.classList.remove('is-active');

    setTimeout(() => {
      (messageBox.querySelector('.js-message-box__single-title') as HTMLElement).innerHTML = '';
    }, 400);
  }, 5000);
};

export const messageBoxError = ({ contentDe, contentEn }: { contentDe: string; contentEn: string }) => {
  const language: string | null = document.documentElement.lang ?? '';

  const messageBox = document.querySelector('.m-message-box__single-error') as HTMLElement;

  if (
    (language === 'en-US' && contentEn == "" )
    || (language !== 'en-US' && contentDe == "" )
  ) {
    return;
  }

  (messageBox.querySelector('.js-message-box__single-title') as HTMLElement).innerHTML = language === 'en-US' ? contentEn : contentDe;
  messageBox.classList.add('is-active');

  setTimeout(() => {
    messageBox.classList.remove('is-active');

    setTimeout(() => {
      (messageBox.querySelector('.js-message-box__single-title') as HTMLElement).innerHTML = '';
    }, 400);
  }, 5000);
};

export const flashMessageBoxDismiss = () => {
  const messageBoxes = document.querySelectorAll('.js-message-box.is-active') as NodeListOf<HTMLElement> | null;

  if (messageBoxes) {
    messageBoxes.forEach((messageBox: HTMLElement) => {
      setTimeout(() => {
        messageBox.classList.remove('is-active');
      }, 5000);
    });
  }
};
